export const indexedSet = () => {
  const map = new Map();
  return {
    get: id => map.get(id),
    add: (id, value) => {
      var _map$get;
      const set = (_map$get = map.get(id)) !== null && _map$get !== void 0 ? _map$get : new Set();
      set.add(value);
      map.set(id, set);
    },
    delete: (id, value) => {
      const set = map.get(id);
      set === null || set === void 0 || set.delete(value);
      if ((set === null || set === void 0 ? void 0 : set.size) === 0) {
        map.delete(id);
      }
    },
    count: () => {
      let count = 0;
      for (const {
        size
      } of map.values()) {
        count += size;
      }
      return count;
    },
    entries: () => map.entries()
  };
};